import * as apiSearchBookings from '@/api/marcom/searchBookings';
import * as apiSearchRequests from '@/api/marcom/searchRequests';
import * as apiGetBookingsOnDeactivatedTables from '@/api/marcom/getBookingsOnDeactivatedTables';
import * as apiAssignCurrentUserAsCaseworker from '@/api/marcom/assignCurrentUserAsCaseworker';
import * as apiUnassignCurrentUserAsCaseworker from '@/api/marcom/unassignCurrentUserAsCaseworker';
import * as apiAssignUserAsCaseworker from '@/api/marcom/assignUserAsCaseworker';
import * as apiGetCaseworkers from '@/api/marcom/getCaseworkers';
import * as apiDeleteBooking from '@/api/marcom/deleteBooking';
import * as apiPostBooking from '@/api/marcom/postBooking';
import * as apiPutBooking from '@/api/marcom/putBooking';
import * as apiGetAvailableSectionTables from '@/api/marcom/getAvailableSectionTables';
import * as apiPatchArrivalState from '@/api/marcom/patchArrivalState';
import * as apiPatchBookingState from '@/api/marcom/patchBookingState';
import * as apiPatchRejectRequest from "@/api/marcom/patchRejectRequest";
import * as apiDeleteBookingTag from "@/api/marcom/deleteBookingTag";
import * as apiPostBookingTag from "@/api/marcom/postBookingTag";
import * as apiGetHosts from "@/api/marcom/getHosts"
import * as apiPatchHosts from "@/api/marcom/patchHosts"
import * as apiPatchBookingCustomer from "@/api/marcom/patchBookingCustomer"
import * as apiGetRejectedRequests from "@/api/marcom/getRejectedRequests"
import * as apiPatchReopendRequest from "@/api/marcom/patchReopenRequest"
import * as apiPatchArrivedCount from "@/api/marcom/patchBookingArrivedCount"
import * as apiPatchArrival from "@/api/marcom/patchBookingArrival"




import { Booking, EnhancedBooking, BOOKING_STATE } from './data-model/bookings';
import { BookingsByDateQuery } from './data-model/bookings/queries-and-commands/bookings-by-date-query';
import { CreateBookingCommand } from './data-model/bookings/queries-and-commands/create-booking-command';
import { VenueTableAndScoreResult } from './data-model/venue-details/venue-table';

export class ExtraItemsList {
  constructor(extraItems) {
    this.extraItems = extraItems;
  }

  totalQuantity() {
    let tot = 0;
    if (this.extraItems) {
      this.extraItems.forEach(i => tot += i.quantity);
    }
    return tot;
  }

  totalPrice() {
    let tot = 0;
    if (this.extraItems) {
      this.extraItems.forEach(i => tot += i.quantity * i.itemPrice);
    }
    return tot;
  }
}

export class ExtraItem {
  constructor(itemName, itemDescription, itemPrice, itemImage, quantity, isSuggested) {
    this.itemImage = itemName;
    this.itemDescription = itemDescription;
    this.itemPrice = itemPrice;
    this.itemImage = itemImage;
    this.quantity = quantity;
    this.isSuggested = isSuggested;
  }
}

export const ACTIONS = {
  MakeReservation: 'MakeReservation',
  AddExtra: 'AddExtra',
  SearchBookings: 'SearchBookings',
  SearchRequests: 'SearchRequests',
  GetBookingsOnDeactivatedTables: 'GetBookingsOnDeactivatedTables',
  AssignCurrentUserAsCaseworker: 'AssignCurrentUserAsCaseworker',
  UnassignCurrentUserAsCaseworker: 'UnassignCurrentUserAsCaseworker',
  AssignUserAsCaseworker: 'AssignUserAsCaseworker',
  GetCaseworkers: 'GetCaseworkers',
  GetHosts: 'GetHosts',
  AssignUserAsHost: 'AssignUserAsHost',
  CreateBooking: 'CreateBooking',
  UpdateBooking: 'UpdateBooking',
  DeleteBooking: 'DeleteBooking',
  UpdateBookingCustomer: 'UpdateBookingCustomer',
  AddPartialArrival: 'AddPartialArrival',
  UpdatePartialArrival: 'UpdatePartialArrival',
  GetAvailableSectionTables: 'GetAvailableSectionTables',
  AcceptRequest: 'AcceptRequest',
  RejectRequest: 'RejectRequest',
  ChangeBookingState: 'ChangeBookingState',
  ChangeArrivalState: 'ChangeArrivalState',
  AddBookingTag: 'AddBookingTag',
  RemoveBookingTag: 'RemoveBookingTag',
  ToggleBookingTag: 'ToggleBookingTag',
  GetRejectedRequests: 'GetRejectedRequests',
  ReopenRequest: 'ReopenRequest',

}
export const MUTATIONS = {
  AddBooking: 'AddBooking',
  GuestConfirmBooking: 'GuestConfirmBooking',
  IsLoadingBookings: 'IsLoadingBookings',
  IsLoadingRequests: 'IsLoadingRequests',
  GotBookings: 'GotBookings',
  GotRequests: 'GotRequests',
  GotBookingsOnDeactivatedTables: 'GotBookingsOnDeactivatedTables',
  RequestAccepted: 'RequestAccepted',
  RequestRejected: 'RequestRejected',
  GotCaseworkers: 'GotCaseworkers',
  GotHosts: 'GotHosts',
  GotRejectedRequests: 'GotRejectedRequests',
  ReopenedRequest: 'ReopenedRequest',
}
export class QueryCommandFactory {
  static getForAction(action, args){
    switch(action) {
      case(ACTIONS.SearchBookings): {
        return new BookingsByDateQuery();
      }
      case(ACTIONS.CreateBooking): {
        return new CreateBookingCommand(args);
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    isLoadingBookings: false,
    isLoadingRequests: false,
    enhancedBookings: [], //contains { booking, bookingCustomer, reservedTable, reservedSection, reservedSetup }
    enhancedRequests: [],
    rejectedRequests: [],
    enhancedBookingsOnDeactivatedTables: [],
    caseworkers: [],
    hosts: [],
  },
  getters: {
    enhancedRequests: state => {
      return state.enhancedRequests;
    },
    rejectedRequests: state => {
      return state.rejectedRequests
    },
    enhancedBookings: state => {
      return state.enhancedBookings;
    },
    enhancedBookingsOnDeactivatedTables: state => {
      return state.enhancedBookingsOnDeactivatedTables;
    },
    caseworkers: state => {
      return state.caseworkers;
    },
    hosts: state => {
      return state.hosts;
    }
  },
  mutations: {
    [MUTATIONS.IsLoadingBookings](state, loading) {
      state.isLoadingBookings = loading;
    },
    [MUTATIONS.GotBookings](state, bookingsWithCustomerAndReservedResultTable) {
      state.enhancedBookings = bookingsWithCustomerAndReservedResultTable;
    },
    [MUTATIONS.IsLoadingRequests](state, loading) {
      state.isLoadingRequests = loading;
    },
    [MUTATIONS.GotRequests](state, requestsWithCustomer) {
      state.enhancedRequests = requestsWithCustomer;
    },
    [MUTATIONS.GotBookingsOnDeactivatedTables](state, bookings) {
      state.enhancedBookingsOnDeactivatedTables = bookings;
    },
    [MUTATIONS.GotCaseworkers](state, caseworkers) {
      state.caseworkers = caseworkers;
    },
    [MUTATIONS.GotHosts](state, hosts) {
      state.hosts = hosts;
    },
    [MUTATIONS.GotRejectedRequests](state, rejectedRequests) {
      state.rejectedRequests = rejectedRequests;
    },
    [MUTATIONS.ReopenedRequest](state, bookingId) {
     
      state.rejectedRequests = state.rejectedRequests.filter((r) => r.booking.bookingId.id != bookingId)
    },

  },
  actions: {
    async [ACTIONS.AddBookingTag]({dispatch}, bookingTagCommand) {
      await apiPostBookingTag.post(bookingTagCommand.booking.id, bookingTagCommand.bookingTag);
    },
    async [ACTIONS.RemoveBookingTag]({dispatch}, bookingTagCommand) {
      await apiDeleteBookingTag.del(bookingTagCommand.booking.id, bookingTagCommand.bookingTag);
    },
    async [ACTIONS.ToggleBookingTag]({dispatch}, bookingTagCommand) {
      let booking = bookingTagCommand.booking;
      if(booking.tags) {
        let index = booking.tags.findIndex(t => t === bookingTagCommand.bookingTag);
        if(index < 0)
          await dispatch(ACTIONS.AddBookingTag, bookingTagCommand);
        else
          await dispatch(ACTIONS.RemoveBookingTag, bookingTagCommand);
      }
      else
        await dispatch(ACTIONS.AddBookingTag, bookingTagCommand);
    },
    async [ACTIONS.ChangeArrivalState](store, changeArrivalStateCommand) {
      await apiPatchArrivalState.patch(changeArrivalStateCommand.booking.id, changeArrivalStateCommand.arrivalState);
    },
    async [ACTIONS.ChangeBookingState](store, changeBookingStateCommand) {
      await apiPatchBookingState.patch(changeBookingStateCommand.booking.id, changeBookingStateCommand.bookingState);
    },
    async [ACTIONS.UpdateBookingCustomer]({ commit, dispatch }, booking ) {
      await apiPatchBookingCustomer.patch(booking.bookingId, booking.bookingCustomer);
    },
    [ACTIONS.AddExtra](store, mod) {
      mod.booking.extraItems.extraItems = mod.extras;
      return new Promise((resolve) => {
        resolve(mod.booking);
        //reject(error);
      });
    },
    async [ACTIONS.SearchBookings]({ commit, dispatch }, bookingQuery) {
      commit(MUTATIONS.IsLoadingBookings, true)

      let result = await apiSearchBookings.get(bookingQuery.from, bookingQuery.to, bookingQuery.venueDetailsId);

      if (result) {
        result = result.map(r => EnhancedBooking.fromJSON(r));
        commit(MUTATIONS.GotBookings, result);
      }

      if(bookingQuery.venueDetailsId)
        await dispatch(ACTIONS.GetBookingsOnDeactivatedTables, bookingQuery.venueDetailsId);

      commit(MUTATIONS.IsLoadingBookings, false);

      return result;
    },
    async [ACTIONS.SearchRequests]({ commit, /*state*/ }, requestQuery) {
      commit(MUTATIONS.IsLoadingRequests, true)

      let result = await apiSearchRequests.get(requestQuery.venue, requestQuery.caseWorkerId);

      if (result) {
        result = result.map(r => EnhancedBooking.fromJSON(r));
        commit(MUTATIONS.GotRequests, result);
      }

      commit(MUTATIONS.IsLoadingRequests, false);

      return result;
    },
    async [ACTIONS.GetBookingsOnDeactivatedTables]({commit}, venueDetailsId) {
      let result = await apiGetBookingsOnDeactivatedTables.get(venueDetailsId);

      if (result) {
        result = result.map(r => EnhancedBooking.fromJSON(r));
        commit(MUTATIONS.GotBookingsOnDeactivatedTables, result);
      }
    },
    async [ACTIONS.AssignCurrentUserAsCaseworker]({ commit, /*state*/ }, booking) {
      const result = await apiAssignCurrentUserAsCaseworker.patch(booking.id);
      // booking.hasNotification = false;
      // booking.caseworkerUser = {
      //   id: result.id
      // }
      return result;
    },
    async [ACTIONS.UnassignCurrentUserAsCaseworker]({ commit, /*state*/ }, booking) {
      const result = await apiUnassignCurrentUserAsCaseworker.patch(booking.id);
      return result;
    },
    async [ACTIONS.AssignUserAsCaseworker]({ commit, /*state*/ }, {booking, userId}) {
      const result = await apiAssignUserAsCaseworker.patch(booking.id, userId.id);
      return result;
    },
    async [ACTIONS.GetCaseworkers]({ commit, /*state*/ }) {
      const result = await apiGetCaseworkers.get();
      commit(MUTATIONS.GotCaseworkers, result);
      return result;
    },

    async [ACTIONS.GetHosts]({ commit, /*state*/ }) {
      const result = await apiGetHosts.get();
      commit(MUTATIONS.GotHosts, result);
      return result;
    },
    async [ACTIONS.AssignUserAsHost]({ commit, /*state*/ }, {booking, userId}) {
      const result = await apiPatchHosts.patch(booking.id, userId.id);
      return result;
    },
    
    async [ACTIONS.CreateBooking]({ commit, /*state*/ }, {createBookingCommand, acceptSoftWarnings}) {
      const result = await apiPostBooking.post(createBookingCommand, acceptSoftWarnings);
      if(result.booking) {
        result.booking = Booking.fromJSON(result.booking);
      }
      return result;
    },
    async [ACTIONS.UpdateBooking]({ commit, /*state*/ }, {booking, acceptSoftWarnings}) {
      const result = await apiPutBooking.put(booking, acceptSoftWarnings);
      if(result.booking) {
        result.booking = Booking.fromJSON(result.booking);
      }
      return result;
    },
    async [ACTIONS.DeleteBooking]({ commit, /*state*/ }, booking) {
      const result = await apiDeleteBooking.del(booking);

      return result;
    },
    async [ACTIONS.GetAvailableSectionTables]({ commit, /*state*/ }, availableTableCommand) {

      let result = await apiGetAvailableSectionTables.get(
        availableTableCommand.bookingId,
        availableTableCommand.numPersons,
        availableTableCommand.arrival,
        availableTableCommand.venueSectionId,
        availableTableCommand.acceptSoftWarnings);
      if(result)
        result = result.map(r => VenueTableAndScoreResult.fromJSON(r));
      return result;
    },
    async [ACTIONS.AcceptRequest]({ commit, /*state,*/ dispatch }, {booking, acceptSoftWarnings}) {
      //booking object has been updated with new data at this point except for the state.
      booking.bookingState = BOOKING_STATE.VenueConfirmed;
      const result = await dispatch(ACTIONS.UpdateBooking, {booking, acceptSoftWarnings});

      //commit(MUTATIONS.RequestAccepted, booking);
      return result;
    },
    async [ACTIONS.RejectRequest]({ commit, /*state*/ }, booking) {
      const result = await apiPatchRejectRequest.patch(booking.id);

      //commit(MUTATIONS.RequestRejected, booking);
      return result;
    },

    async [ACTIONS.ReopenRequest]({ commit, /*state*/ }, booking) {
      const result = await apiPatchReopendRequest.patch(booking.id);

      commit(MUTATIONS.ReopenedRequest, booking.id);
      return result;
    },


    async [ACTIONS.GetRejectedRequests]({ commit, /*state*/ }, venueDetailsId) {
      const result = await apiGetRejectedRequests.get(venueDetailsId);
      commit(MUTATIONS.GotRejectedRequests, result)
      return result;
    },

    async [ACTIONS.AddPartialArrival]({ dispatch, getters }, { booking, arrival }) {
      console.log("ACTION",booking)
      var result = await apiPatchArrivedCount.patch(booking.id, arrival);
      
      return result
    },
    async [ACTIONS.UpdatePartialArrival]({ dispatch, getters }, { booking, arrival }) {
      var result = await apiPatchArrival.patch(booking.id, arrival);
      
      return result
    },


  }
};


